import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { VerificationComponent } from './verification/verification.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'verify',
    title: 'Alphastar | OTP Verification',
    component: VerificationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
